import * as S from './styled'

type PropTypes = {
  title: string
}

export function Header({ title }: PropTypes) {
  return (
    <S.GridHeader>
      <S.GridTitle item container xs={12}>
        <S.BoxTitle>{title}</S.BoxTitle>
      </S.GridTitle>
    </S.GridHeader>
  )
}
